const scrollToTopBtn = document.getElementById("scrollToTop");


// If there's no button on this page, do nothing and exit safely
if (!scrollToTopBtn) {
    console.log("No #scrollToTop button on this page");
} else {
    window.addEventListener("scroll", () => {
        if (window.scrollY > 300) {
            scrollToTopBtn.style.display = "flex"; // Show button
        } else {
            scrollToTopBtn.style.display = "none"; // Hide button
        }
    });


    scrollToTopBtn.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}
